import { render, staticRenderFns } from "./ItemDetailDefaultLayout.vue?vue&type=template&id=ad25423a&scoped=true"
import script from "./ItemDetailDefaultLayout.vue?vue&type=script&lang=js"
export * from "./ItemDetailDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad25423a",
  null
  
)

export default component.exports